import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { RootState } from 'store';
import { setReqHeaders } from 'utils/common';
import { addPwPrefixToBaseUrl } from 'utils/pwContext';
import { getSessionId } from 'utils/session';

export const createBaseQueryWithPwPrefix = (baseUrl: string) => {
  const modifiedBaseUrl = addPwPrefixToBaseUrl(baseUrl);

  return fetchBaseQuery({
    baseUrl: modifiedBaseUrl,
    prepareHeaders(headers, { getState, endpoint }) {
      const { sessionId: sessionIdFromStore } = (getState() as RootState).common;
      const sessionId = getSessionId(sessionIdFromStore);

      setReqHeaders(headers, {
        sessionId,
        sessionIdFromStore,
        endpoint,
      });
    },
  });
};
